export default __webpack_public_path__ + "static/media/trailer-red.5304be9a.svg";